import { DesignLayoutType } from '@graphql/generated';

// not permanent solution
const SUPPORT_HEADER_SCHEMA_BY_LAYOUT = {
  aloha: new Set([
    // center
    'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',

    // photo slider
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
  ]),
  brannan: new Set([
    // monogram
    'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',

    // center
    'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',

    // full width
    'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',

    // page width
    'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',

    // photo slider
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',

    // photo trio
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',

    // photo trio page width
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',

    // no photo
    'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',

    // photo arch
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',

    // photo duo left
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',

    // photo duo right
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',

    // photo marquee
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',

    // photo background
    'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',

    // video background
    'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',

    // video arch
    'https://withjoy.com/assets/public/websiteHeaderSchemas/videoArch-v1_1_1.json',
  ]),
};

/**
 * @todo
 * - Add schema validation https://withjoy.atlassian.net/browse/PRNT-2869
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isValidSchema = <T>(websiteLayout: DesignLayoutType, schemaURL: string, dataJSON: any): dataJSON is T => {
  return SUPPORT_HEADER_SCHEMA_BY_LAYOUT[websiteLayout]?.has(schemaURL) && !!dataJSON;
};
